import React, { useState, useEffect } from 'react';
import twinseyeLogo from '../images/TwinSeye-Logo-Text.png';
import backgroundImage from "../images/Twinseye-Background.png";
import styles from './IntroPages.module.css';
import { getLanguageBasedImage } from '../languageutil/ImageUtil';

function CompanyTypeSelectPage({ navigate }) {
  const [newCompanyButton, setNewCompanyButton] = useState(null);
  const [savedCompanyButton, setSavedCompanyButton] = useState(null);

  useEffect(() => {
    setNewCompanyButton(getLanguageBasedImage('YeniSirketButton.png'));
    setSavedCompanyButton(getLanguageBasedImage('KayitliSirketButton.png'));
  }, []);

  return (
    <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", fontFamily: "Bookman Old Style", flexDirection: "column", justifyContent: "start" }}>
      <div style={{ position: "absolute", top: "0vh", left: "0vw", height: "20vh", width: "100vw", backgroundColor: "white" }} />
      <img src={twinseyeLogo} alt="CoreXFuture" style={{ position: "absolute", top: "3vh", left: "4vw", height: "14vh", alignSelf: "center" }} />
      <div className={styles.content} style={{ height: "50vh", display: "flex", alignItems: "center", marginTop: "30vh" }}>
        <div className={styles.leftside} style={{ height: "auto", justifyContent: "normal" }}>
          <div className={styles.buttoncontainer} style={{ display: "flex", justifyContent: "end", marginRight: "3vw" }}>
            <img src={savedCompanyButton} alt="Saved Company" className={styles.startbutton} style={{ width: "40vw" }} onClick={() => { navigate("/entercompanyname/saved"); }} />
          </div>
        </div>
        <div className={styles.leftside} style={{ height: "auto", justifyContent: "normal" }}>
          <div className={styles.buttoncontainer} style={{ display: "flex", justifyContent: "start", marginLeft: "3vw" }} >
            <img src={newCompanyButton} alt="New Company" className={styles.startbutton} style={{ width: "40vw" }} onClick={() => { navigate("/entercompanyname/new"); }} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyTypeSelectPage;